import React from 'react';
import { FormattedMessage, injectIntl } from 'react-intl';
import useStyles from 'isomorphic-style-loader/useStyles';
import s from './About.css';
import useScrollReveal from '../../hooks/useScrollReveal';
import messages from '../../../../locale/messages';

function About({ intl }) {
  useStyles(s);
  const { ref, isVisible } = useScrollReveal();

  return (
    <section id="about" className={s.about} ref={ref}>
      <div className={s.inner}>
        <div className={`${s.left} ${isVisible ? s.leftVisible : ''}`}>
          <img
            src="/SiteImages/about_us.webp"
            alt={intl.formatMessage(messages.homeAboutImageAlt)}
          />
        </div>
        <div className={`${s.right} ${isVisible ? s.rightVisible : ''}`}>
          <p className={s.eyebrow}>
            <FormattedMessage {...messages.homeAboutEyebrow} />
          </p>
          <h2 className={s.title}>
            <FormattedMessage {...messages.homeAboutTitle} />
          </h2>
          <p className={s.text}>
            <FormattedMessage {...messages.homeAboutTextOne} />
            <br />
            <FormattedMessage {...messages.homeAboutTextTwo} />
          </p>
          <a href="https://linktr.ee/DOWNLOADASAP" className={s.btnPrimary} style={{ textDecoration: 'none', color: '#ffffff' }}>
            <FormattedMessage {...messages.homeOrderNow} />
          </a>
        </div>
      </div>
    </section>
  );
}

export default injectIntl(About);
